import Fetch from '../Fetch';

export default {
  queryLicenseList: () => { // License列表
    return Fetch.get(`/api/v1/sw_licenses`);
  },

  licenseUpload: '/api/v1/sw_license_upload', // License 上传

  saveLicenseInfo: (params) => { // 保存license
    return Fetch.post(`/api/v1/sw_license_key`, params);
  },

  deleteLicense: () => { // delete License
    return Fetch.post(`/api/v1/sw_license_del`);
  },
};
